import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, MapPin, Phone, Mail, Power, PowerOff } from 'lucide-react';
import { centres as centresData } from '../../data/mockData';

function ListeCentres({ user }) {
  const [centres, setCentres] = useState(centresData);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCentres = centres.filter(centre =>
    centre.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    centre.ville.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleActif = (centreId) => {
    setCentres(centres.map(c =>
      c.id === centreId ? { ...c, actif: !c.actif } : c
    ));
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Centres de lavage</h1>
          <p className="text-muted">Gestion des centres de lavage</p>
        </div>
        {user.role === 'admin' && (
          <Link to="/centres/nouveau" className="btn btn-primary">
            <Plus size={20} />
            Ajouter un centre
          </Link>
        )}
      </div>

      <div className="filters-bar">
        <input
          type="text"
          placeholder="Rechercher un centre..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="centres-grid">
        {filteredCentres.map(centre => (
          <div key={centre.id} className={`centre-card ${!centre.actif ? 'inactive' : ''}`}>
            <div className="centre-card-header">
              <div>
                <h3>{centre.nom}</h3>
                <span className={`badge ${centre.actif ? 'badge-success' : 'badge-secondary'}`}>
                  {centre.actif ? 'Actif' : 'Inactif'}
                </span>
              </div>
              {user.role === 'admin' && (
                <div className="centre-actions">
                  <Link
                    to={`/centres/${centre.id}/modifier`}
                    className="btn btn-sm btn-secondary"
                    title="Modifier"
                  >
                    <Edit size={16} />
                  </Link>
                  <button
                    onClick={() => toggleActif(centre.id)}
                    className={`btn btn-sm ${centre.actif ? 'btn-danger' : 'btn-success'}`}
                    title={centre.actif ? 'Désactiver' : 'Activer'}
                  >
                    {centre.actif ? <PowerOff size={16} /> : <Power size={16} />}
                  </button>
                </div>
              )}
            </div>

            <div className="centre-card-body">
              <div className="info-row">
                <MapPin size={16} className="icon-muted" />
                <div>
                  <p>{centre.adresse}</p>
                  <p>{centre.codePostal} {centre.ville}</p>
                </div>
              </div>

              <div className="info-row">
                <Phone size={16} className="icon-muted" />
                <p>{centre.telephone}</p>
              </div>

              <div className="info-row">
                <Mail size={16} className="icon-muted" />
                <p>{centre.email}</p>
              </div>

              {centre.coordonneesGPS && (
                <div className="info-row">
                  <MapPin size={16} className="icon-muted" />
                  <p className="text-muted">
                    GPS: {centre.coordonneesGPS.latitude}, {centre.coordonneesGPS.longitude}
                  </p>
                </div>
              )}
            </div>

            <div className="centre-card-footer">
              <p className="text-sm text-muted">
                Créé le {new Date(centre.dateCreation).toLocaleDateString('fr-FR')}
              </p>
            </div>
          </div>
        ))}
      </div>

      {filteredCentres.length === 0 && (
        <div className="empty-state">
          <p>Aucun centre trouvé</p>
        </div>
      )}
    </div>
  );
}

export default ListeCentres;

